import { AnimatePresence, motion } from 'framer-motion';

import { Photo } from '../Photo/Photo';
import { BgVideo } from '../BgVideo/BgVideo';

import styles from './Message.module.css';

import { useGetParams } from '../../hooks/useGetParams';

const Message = ({ currentMessage, message, rotateSign, duration }) => {
  const durationSec = duration / 1000;
  const endpointStart = 0.33;
  const exitDuration = 0.18 * durationSec;
  const allStartDuration = durationSec - exitDuration;
  const startDutation = allStartDuration * endpointStart;

  const { title, qrCode1, qrCode2 } = useGetParams();

  const sizeQR = '27.7';

  const wordsTitle = title?.split(' ');

  return (
    <div className={styles.wrapper}>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentMessage?.id}
          exit={{
            x: '100vw',
            scale: 0.5,
            opacity: 0,
            transition: {
              duration: exitDuration,
            },
          }}
          className={styles.photoBlock}
        >
          {message && (
            <Photo
              message={message}
              rotateSign={rotateSign}
              startDutation={startDutation}
            />
          )}
        </motion.div>
      </AnimatePresence>

      <div className={styles.advtBlock}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          className={styles.titleBlock}
        >
          {wordsTitle &&
            wordsTitle.map((word, idx) => (
              <div key={word + idx} className={styles.titleWord}>
                {word}
              </div>
            ))}
        </motion.div>

        <div className={styles.qrsWrapper}>
          {qrCode1 && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6 }}
              className={styles.qrCode}
            >
              <img
                src={qrCode1}
                alt="QR"
                style={{
                  height: `${sizeQR}rem`,
                  width: `${sizeQR}rem`,
                }}
              />
            </motion.div>
          )}
          {qrCode2 && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className={styles.qrCode}
            >
              <img
                src={qrCode2}
                alt="QR"
                style={{
                  width: `${sizeQR}rem`,
                  height: `${sizeQR}rem`,
                }}
              />
            </motion.div>
          )}
        </div>
      </div>

      <BgVideo />
    </div>
  );
};

export default Message;
